import { gql } from "@apollo/client";

export const POLES = gql`
  query Poles(
    $where: PoleWhereInput
    $isIn: JSONObject
    $take: Int
    $skip: Int
  ) {
    poles(where: $where, take: $take, skip: $skip, isIn: $isIn) {
      data {
        id
        users {
          id
        }
      }
      count
    }
  }
`;

export const POLE = gql`
  query Pole($where: PoleWhereInput) {
    pole(where: $where) {
      id
      users {
        id
      }
    }
  }
`;

const poles = { POLES, POLE };

export default poles;
